export default __webpack_public_path__ + "static/media/processing-image.419133e7.png";